<template>
  <div class="modal fade" :class="$props.class" tabindex="-1" ref="modal1">
    <div :class="dialogClass">

      <div class="modal-content">

        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          :aria-label="$t('adm.button.close')"
          :title="$t('adm.button.close')" />

        <slot>MODAL CONTENT</slot>

      </div>

    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { Modal } from 'bootstrap';
import { Logger } from 'oidc-client-ts';

export default defineComponent({
  name: 'StihlModal',
  emits: ['modalClosed'],
  props: {
    class: { type: String, default: null },
    dialogClass: { type: String, default: 'modal-dialog modal-dialog-centered' },
  },
  computed: {
    rootElem(): HTMLDivElement | undefined {
      return this.$refs.modal1 as HTMLDivElement;
    },
    modal(): Modal | undefined {
      return this.rootElem ? Modal.getOrCreateInstance(this.rootElem) : undefined;
    },
  },
  mounted() {
    Logger.debug('modal', 'mounted');
    this.modal?.show();
    this.rootElem?.addEventListener('hidden.bs.modal', () => this.$emit('modalClosed'));
  },
  beforeUnmount() {
    Logger.debug('modal', 'unmounting');
    this.modal?.hide(); // we need this to hide the overlay, when the modal is closed by router (ex: go back in history)
  },
});
</script>

<style scoped>
.modal .btn-close {
  position: absolute;
  top: 0;
  right: 0;

  --bs-btn-close-bg: url("@/assets/img/icons/close.svg");
  --bs-btn-close-opacity: 1;
  --bs-btn-close-hover-opacity: 1;

  background-color: black;

  padding: .5rem;
}

.modal .btn-close:hover {
  background-color: var(--orange-base);
  transition: background-color .3s ease-out;
}

.modal-content {
  padding: var(--stihl-modal-content-padding, 3.5rem);
  gap: var(--stihl-modal-content-gap);
}
</style>
